import React from "react";
import { WPTaxTerm } from "../../../../constants/types";
import { useTaxonomies } from "../../../../services/app-state";
import { useAssessmentState } from "../../../../services/assessment-state";
import { AssessmentState } from "../../../../services/assessment-state/types";
import { TextButton, TextButtonGroup } from "../shared/TextButton";
import { AssessmentCopy } from "../utils";


export const About: React.FC = () => {
    const [{ communities }] = useTaxonomies();
    const { isForSelf, state, setState } = useAssessmentState();

    const handleConditionClick = (community: WPTaxTerm) => {
        const { communities } = state;
        
        // If exists, remove
        if (communities.includes(`${community.id}`)) {

            const communityFilter = communities.filter(c => c != `${community.id}`);
            if (community.name.toLocaleLowerCase().includes('lgbtq')) {
                setState({
                    lgbtq: false,
                    communities: communityFilter
                });
            } else if (community.name.toLocaleLowerCase().includes('aboriginal')) {
                setState({
                    atsi: false,
                    communities: communityFilter
                });
            } else if (community.name.toLocaleLowerCase().includes('cultural')) {
                setState({
                    multicultural: false,
                    communities: communityFilter
                });
            } else {
                setState({
                    communities: communityFilter
                });
            }
        }
        // If not, add
        else {
            if (community.name.toLocaleLowerCase().includes('lgbtq')) {
                setState({
                    lgbtq: true,
                    communities: [...state.communities, `${community.id}`],
                });
            }
            if (community.name.toLocaleLowerCase().includes('aboriginal')) {
                setState({
                    atsi: true,
                    communities: [...state.communities, `${community.id}`],
                });
            }
            if (community.name.toLocaleLowerCase().includes('cultural')) {
                setState({
                    multicultural: true,
                    communities: [...state.communities, `${community.id}`],
                });
            } else {
                setState({
                    communities: [...state.communities, `${community.id}`],
                });
            }
        }
    };

    return (
        <>
            <TextButtonGroup className="selection-container" title={AssessmentCopy.COMMUNITY[isForSelf ? "SELF" : "CARER"]}>
                {communities.map(community => {
                    if (community.acf.nswtb_process_title != '') {
                        return (
                            <TextButton
                                key={community.id}
                                onClick={() => {
                                    handleConditionClick(community);
                                }}
                                isActive={state.communities?.includes(`${community.id}`)}
                            >
                                {community.acf?.nswtb_process_title}
                            </TextButton>
                        )
                    }
                })}
            </TextButtonGroup>
        </>
    );
};

export default {
    Component: About,
    createMeta: (state: AssessmentState) => ({
        title:
            state.target === "MYSELF"
                ? "A little about you"
                : "A little about the person seeking support",
        canProgress: true,
        canSkip: true,
    }),
};

